(function (Drupal, once) {
  Drupal.behaviors.linkNoreferrerFix = {
    attach(context) {
      const links = once('linkNoreferrerFix', 'a', context);
      if (links.length > 0) {
        links.forEach(item => {
          if (location.hostname !== item.hostname) {
            item.setAttribute('rel', 'nofollow noopener noreferrer');
          }
        })
      }
    },
  }
})(Drupal, once)